








import { Component, Vue } from 'vue-property-decorator';
import layout from '@/layouts/basic-layout.vue';
import ForgotPasswordForm from '@/components/forgot-password-form.vue';

@Component({
    components: {
        layout,
        'forgot-password-form': ForgotPasswordForm,
    },
})
export default class ForgotPassword extends Vue {
}
